import { useState, useEffect } from "react";
import {
  Menu,
  X,
  Home,
  Users,
  MessageCircle,
  Settings,
  MessageSquare,
  Plus,
  ChartArea,
  ListOrdered,
} from "lucide-react";
import { NavLink, Link, useLocation } from "react-router-dom";
import logo from "../assets/images/logo.jpg"; // ✅ import logo

export default function MobileHeader() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    {
      name: "Home",
      icon: <Home className="w-5 h-5" />,
      path: "/dashboard",
      end: true,
    },
    {
      name: "Add Funds",
      icon: <Plus className="w-5 h-5" />,
      path: "/dashboard/add/money",
    },
    {
      name: "SMS Verification",
      icon: <MessageSquare className="w-5 h-5" />,
      path: "/dashboard/BuySmsRoutePage",
    },
    {
      name: "SMS Orders",
      icon: <ListOrdered className="w-5 h-5" />,
      path: "/dashboard/SmsOrder",
    },
    {
      name: "Transactions",
      icon: <ChartArea className="w-5 h-5" />,
      path: "/dashboard/transactions",
    },
    {
      name: "Community",
      icon: <Users className="w-5 h-5" />,
      path: "/dashboard/community",
    },
    {
      name: "Chat Us",
      icon: <MessageCircle className="w-5 h-5" />,
      path: "/dashboard/chat",
    },
    {
      name: "Settings",
      icon: <Settings className="w-5 h-5" />,
      path: "/dashboard/settings",
    },
  ];

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => (document.body.style.overflow = "");
  }, [isOpen]);

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  return (
    <>
      {/* Mobile header (visible only on < md) */}
      <header className="md:hidden fixed top-0 left-0 right-0 z-40 bg-white shadow flex items-center justify-between px-4 py-3">
        {/* Brand on the left */}
        <Link
          to="/dashboard"
          className="flex items-center gap-2 text-lg font-bold text-[#007AFF]"
        >
          <img
            src={logo}
            alt="DottiVerify Logo"
            className="h-8 w-8 object-cover rounded-full"
          />
          <span>Dotti Verify</span>
        </Link>

        {/* Menu button on the right */}
        <button
          onClick={() => setIsOpen(true)}
          aria-label="Open navigation"
          className="p-2 rounded-md hover:bg-gray-100"
        >
          <Menu className="w-6 h-6 text-gray-700" />
        </button>
      </header>

      {/* overlay */}
      <div
        className={`fixed inset-0 z-50 bg-black bg-opacity-50 transition-opacity ${
          isOpen ? "opacity-100 visible" : "opacity-0 invisible"
        } md:hidden`}
        onClick={() => setIsOpen(false)}
        aria-hidden={!isOpen}
      />

      {/* sliding drawer */}
      <aside
        className={`fixed top-0 right-0 h-full w-64 bg-white shadow-lg z-50 transform transition-transform duration-300 md:hidden ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
        aria-hidden={!isOpen}
      >
        <div className="flex items-center justify-between px-6 py-6 border-b">
          <Link
            to="/dashboard"
            className="flex items-center gap-2 text-lg font-bold text-[#007AFF]"
          >
            <img
              src={logo}
              alt="DottiVerify Logo"
              className="h-8 w-8 object-cover rounded-full"
            />
            <span>Dotti Verify</span>
          </Link>
          <button
            onClick={() => setIsOpen(false)}
            aria-label="Close navigation"
            className="p-2 rounded-md hover:bg-gray-100"
          >
            <X className="w-6 h-6 text-gray-700" />
          </button>
        </div>

        <nav className="px-4 py-6 space-y-2 overflow-y-auto h-[calc(100vh-96px)]">
          {navItems.map((item) => {
            const isActive = item.end
              ? location.pathname === item.path
              : location.pathname.startsWith(item.path);

            return (
              <NavLink
                key={item.name}
                to={item.path}
                end={item.end}
                onClick={() => setIsOpen(false)}
                className={`flex items-center gap-3 px-4 py-2 rounded-lg transition ${
                  isActive
                    ? "bg-[#007AFF] text-white"
                    : "text-gray-600 hover:bg-gray-100"
                }`}
              >
                {item.icon}
                <span>{item.name}</span>
              </NavLink>
            );
          })}
        </nav>
      </aside>
    </>
  );
}
